
import { Component, Prop, Vue, toNative } from 'vue-facing-decorator';
@Component
class EmailBrandingDrawer extends Vue {
  @Prop() private drawerWidth!: string;
  private isTabView = false;
  private isTabLandscapeView = false;

  private mounted(){
    // Check for mobile view
    if(window.innerWidth <= 991){
      this.isTabView = true;
    }else{
      this.isTabView = false;
    }
    // Check if it is landscape view of tab
    if(window.innerWidth >= 991 && window.innerWidth <= 1200) {
      this.isTabLandscapeView = true;
    } else {
      this.isTabLandscapeView = false;
    }
  }
}
export default toNative(EmailBrandingDrawer);
